// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Jordan */
const JO = /^(?:(?:427|7(?:[78][0-25-9]|9\d))\d{6})$/;

export default JO;
